import script from "./tourament-details.vue?vue&type=script&setup=true&lang=js"
export * from "./tourament-details.vue?vue&type=script&setup=true&lang=js"

import "./tourament-details.vue?vue&type=style&index=0&id=038d0a96&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-038d0a96"]])

export default __exports__